import { ErrorCodeAction, ProductAction } from '../../actions';
import { RayTable, AdminProductErrorListHeader, AdminProductErrorListHeader2 } from '../common';
import { connect } from 'react-redux';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { NoRecord } from '../../pages/HomePage';
import moment from 'moment';
import { Translate as t } from '../../config/Translate';

const ProductInfoError = ({ errorCodes, product, RequestErrorLogFile, GetAllErrorCodes, _sn, AddErrorMailException, RemoveErrorMailException, GetErrorMailExceptions, user }) => {
	const [errs, setErrs] = useState([]);
	const [errorMailExceptions, setErrorMailExceptions] = useState([]);
	const [muteTarget, setMuteTarget] = useState(null);

	// 권한 체크 — UI 노출 제어용 (실제 권한 검증은 BE에서 수행)
	const isManager = user && (user.adminType === 'S' || user.adminType === 'M');

	const getLogRType = (x) => {
		let type = t('product.errorLog.notRequested');
		if (x.hasOwnProperty("emsrequestlog")) {
			if (x.hasOwnProperty("emsresponseresult")) {
				type = x.emsresponseresult ? t('common.status.success') : t('service.label.resultFail');
			} else {
				type = t('common.label.wait')
			}
		}
		return type;
	}

	const options = {
		search: true,
		keyCol: "code",
		linkto: '/Admin/AdminErrorCodeInfo',
		linkkey: ['code', 'lang'],
		filterColumns: [
			{ col: "code", val: "ALL" },
			{ col: "closer", val: "ALL" },
			{ col: "emslogrtype", val: "ALL" },
		],
		filterpageoption: {
			filterDateOptions: [
				{ code: "begin", label: t('common.button.begin') }
			]
		},
		defaultSort: "begin",
		defaultSortType: -1
	}

	const requestLogCallback = (item) => {
		RequestErrorLogFile(product.sn, item._id);
	}

	const getDefinition = (errorCode) => {
		const result = errorCodes.find(x => x.errorCode === errorCode && x.model.includes(product.model));
		return result ? result.definition : '';
	}

	const getDuration = (begin, end) => {
		if (end) {
			begin = moment(begin);
			end = moment(end);

			const seconds = end.diff(begin, 'seconds');
			const minutes = Math.trunc(seconds / 60);
			const hours = Math.trunc(minutes / 60);
			const days = Math.trunc(hours / 24);

			if (days > 0)
				return `${days} ${t(days > 1 ? 'product.duration.days' : 'product.duration.day')}`;
			else if (hours > 0)
				return `${hours} ${t(hours > 1 ? 'product.duration.hours' : 'product.duration.hour')}`;
			else if (minutes > 0)
				return `${minutes} ${t(minutes > 1 ? 'product.duration.minutes' : 'product.duration.minute')}`;
			else
				return `${seconds} ${t(seconds > 1 ? 'product.duration.seconds' : 'product.duration.second')}`;
		} else {
			return '';
		}
	}

	const isMuted = (errorCode) => {
		return errorMailExceptions.some(e => e.errorCode === errorCode && !e.isDel);
	}

	const handleMuteToggle = async (item) => {
		if (isMuted(item.code)) {
			await RemoveErrorMailException(product.sn, item.code);
			await loadExceptions();
		} else {
			setMuteTarget(item);
		}
	}

	const confirmMute = async () => {
		if (!muteTarget) return;
		await AddErrorMailException(product.sn, muteTarget.code, muteTarget.description || '');
		setMuteTarget(null);
		await loadExceptions();
	}

	const loadExceptions = useCallback(async () => {
		if (product?.sn) {
			const result = await GetErrorMailExceptions(product.sn);
			setErrorMailExceptions(result || []);
		}
	}, [product?.sn, GetErrorMailExceptions]);

	const uniqueErrorCodes = useMemo(() => {
		return [...new Map(errs.map(e => [e.code, e])).values()];
	}, [errs]);

	useEffect(() => {
		GetAllErrorCodes();
	}, []);

	useEffect(() => {
		loadExceptions();
	}, [loadExceptions]);

	useEffect(() => {
		const list = [];
		product.errs.forEach(x => {
			list.push({
				...x,
				sn: product.sn,
				logRequested: x.emsrequestlog,
				emslogrtype: getLogRType(x),
				definition: getDefinition(x.code),
				status: x.closer ? t('common.status.closed') : t('service.label.notClosed'),
				duration: getDuration(x.begin, x.end),
				lang: 'eng',
				mailMuted: isMuted(x.code)
			})
		})
		setErrs(list);
	}, [product, errorMailExceptions])

	return (
		<div className="section">
			<div className="card">
				<div className="card-body">
					{errs.length > 0 &&
						<>
							<RayTable
								data={errs}
								parentData={product}
								calllback={requestLogCallback}
								columns={AdminProductErrorListHeader2}
								options={options} />
							{isManager && (
								<div className="mt-3 border-top pt-3">
									<h6 className="fw-bold mb-2">
										<ion-icon name="mail-outline" class="me-1" />
										{t('notification.email.alert') || 'Mail Alert'}
									</h6>
									<div className="table-responsive">
										<table className="table table-sm table-hover mb-0">
											<thead>
												<tr>
													<th>{t('product.field.errorCode') || 'Error Code'}</th>
													<th>{t('common.field.description') || 'Description'}</th>
													<th>{t('notification.email.alert') || 'Mail Alert'}</th>
												</tr>
											</thead>
											<tbody>
												{uniqueErrorCodes.map(err => (
													<tr key={err.code} style={isMuted(err.code) ? { backgroundColor: '#f8f9fa' } : {}}>
														<td><code>{err.code}</code></td>
														<td className="text-muted" style={{ fontSize: '0.85em' }}>{err.definition || err.description || '-'}</td>
														<td>
															<button
																className={`btn btn-sm ${isMuted(err.code) ? 'btn-outline-secondary' : 'btn-outline-primary'}`}
																onClick={() => handleMuteToggle(err)}
															>
																{isMuted(err.code) ? (
																	<><ion-icon name="notifications-off-outline" class="me-1" />{t('common.status.muted')}</>
																) : (
																	<><ion-icon name="notifications-outline" class="me-1" />{t('common.status.active')}</>
																)}
															</button>
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
							)}
						</>
					}
					{errs.length === 0 &&
						<NoRecord title={t('service.message.noIssues')} contents={t('service.message.info.thereIsNoIssueHistory')} _sn={_sn} widthsection={true} />
					}
				</div>
			</div>

			{muteTarget && (
				<div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
					<div className="modal-dialog modal-dialog-centered">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">{t('notification.email.alertMute') || 'Mute Mail Alert'}</h5>
								<button type="button" className="btn-close" onClick={() => setMuteTarget(null)} />
							</div>
							<div className="modal-body">
								<p>{t('notification.email.alertMuteConfirm') || 'Are you sure you want to mute mail alerts for this error?'}</p>
								<table className="table table-sm mb-2">
									<tbody>
										<tr><th style={{ width: '30%' }}>{t('product.field.sn')}</th><td>{product.sn}</td></tr>
										<tr><th>{t('product.field.errorCode')}</th><td><code>{muteTarget.code}</code></td></tr>
										<tr><th>{t('common.field.description')}</th><td>{muteTarget.definition || muteTarget.description || '-'}</td></tr>
									</tbody>
								</table>
								<div className="alert alert-info mb-0" style={{ fontSize: '0.85em' }}>
									<ion-icon name="information-circle-outline" class="me-1" />
									{t('notification.email.alertMuteNote') || 'Errors will still be recorded. Only mail notifications will be stopped.'}
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" onClick={() => setMuteTarget(null)}>{t('common.button.cancel') || 'Cancel'}</button>
								<button type="button" className="btn btn-warning" onClick={confirmMute}>
									<ion-icon name="notifications-off-outline" class="me-1" />
									{t('notification.email.mute') || 'Mute'}
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

const mapState = (state) => {
	const errorCodes = state.ErrorCodeReducer.errorCodes;
	const user = state.AuthReducer?.user || {};
	return { errorCodes, user };
};

const mapDispatch = (dispatch) => ({
	RequestErrorLogFile: (sn, errId) => dispatch(ProductAction.RequestErrorLogFile(sn, errId)),
	GetAllErrorCodes: () => dispatch(ErrorCodeAction.GetList()),
	AddErrorMailException: (sn, errorCode, description) => dispatch(ProductAction.AddErrorMailException(sn, errorCode, description)),
	RemoveErrorMailException: (sn, errorCode) => dispatch(ProductAction.RemoveErrorMailException(sn, errorCode)),
	GetErrorMailExceptions: (sn) => dispatch(ProductAction.GetErrorMailExceptions(sn)),
});

export default connect(mapState, mapDispatch)(ProductInfoError);
